import { graphql, readFragment } from "@opensea/graphql";
import { useIsLessThanMd } from "@opensea/ui-kit";
import { CollectionBannerImageFragment, getCollectionBannerFallbackImage, getCollectionBannerImage } from "./utils";
export const useCollectionBannerMediaFragment = graphql(`
    fragment useCollectionBannerMedia on Collection {
      ...CollectionBannerImage
      hero {
        desktopHeroMedia {
          __typename
          ... on ImageMedia {
            imageUrl
          }
          ... on VideoMedia {
            videoUrl
          }
          ... on MuxVideoMedia {
            muxPlaybackId
          }
        }
        mobileHeroMedia {
          __typename
          ... on ImageMedia {
            imageUrl
          }
          ... on VideoMedia {
            videoUrl
          }
          ... on MuxVideoMedia {
            muxPlaybackId
          }
        }
      }
    }
  `, [CollectionBannerImageFragment]);
export const useCollectionBannerMediaFallbackFragment = graphql(`
    fragment useCollectionBannerMediaFallback on Collection {
      ...CollectionBannerImage
      hero {
        desktopHeroMedia {
          ... on VideoMedia {
            thumbnailUrl
          }
          ... on MuxVideoMedia {
            thumbnailUrl
          }
        }
        mobileHeroMedia {
          ... on VideoMedia {
            thumbnailUrl
          }
          ... on MuxVideoMedia {
            thumbnailUrl
          }
        }
      }
    }
  `, [CollectionBannerImageFragment]);
export const useCollectionBannerMedia = collectionKey => {
  const collection = readFragment(useCollectionBannerMediaFragment, collectionKey);
  const legacyBannerImage = getCollectionBannerImage(collection);
  const isLessThanMd = useIsLessThanMd();
  const primaryHeroMedia = isLessThanMd ? collection?.hero?.mobileHeroMedia : collection?.hero?.desktopHeroMedia;
  const fallbackHeroMedia = isLessThanMd && !primaryHeroMedia ? collection?.hero?.desktopHeroMedia : null;
  const heroMedia = primaryHeroMedia || fallbackHeroMedia;
  let heroMediaUrl = null;
  switch (heroMedia?.__typename) {
    case "VideoMedia":
      heroMediaUrl = heroMedia.videoUrl;
      break;
    case "ImageMedia":
      heroMediaUrl = heroMedia.imageUrl;
      break;
    case "MuxVideoMedia":
      heroMediaUrl = heroMedia.muxPlaybackId;
      break;
    default:
      heroMediaUrl = null;
  }
  return heroMediaUrl || legacyBannerImage;
};
export const useCollectionBannerMediaFallback = collectionKey => {
  const collection = readFragment(useCollectionBannerMediaFallbackFragment, collectionKey);
  const legacyBannerFallbackImage = getCollectionBannerFallbackImage(collection);
  const isLessThanMd = useIsLessThanMd();
  const primaryHeroMedia = isLessThanMd ? collection?.hero?.mobileHeroMedia : collection?.hero?.desktopHeroMedia;
  const fallbackHeroMedia = isLessThanMd && !primaryHeroMedia ? collection?.hero?.desktopHeroMedia : null;
  const heroMedia = primaryHeroMedia || fallbackHeroMedia;
  let fallbackMediaUrl = legacyBannerFallbackImage;
  switch (heroMedia?.__typename) {
    case "VideoMedia":
    case "MuxVideoMedia":
      fallbackMediaUrl = heroMedia.thumbnailUrl;
      break;
    default:
      fallbackMediaUrl = legacyBannerFallbackImage;
  }
  return fallbackMediaUrl;
};